/**
 * Look for all dismissible call out elements.
 * Make them the same height.
 */
export function callOutBlock() {
    let blocks = document.querySelectorAll('.call-out-block__content');

    for (let i = 0; i < blocks.length; i++) {
        let block = blocks[ i ];

        block.nextElementSibling.style.height = block.clientHeight + 'px';
    }
}


/**
 * Look for all dismissible content elements.
 * Set them up to open or close on click.
 */
export function dismissibleContent() {
    const elements = document.querySelectorAll('.dismissible-content');

    for(let i = 0; i < elements.length; i++) {
        elements[i].querySelector('.open-button').addEventListener('click', openDismissibleContent.bind(elements[i]));
        elements[i].querySelector('.close-button').addEventListener('click', closeDismissibleContent.bind(elements[i]));
    }
}

/**
 * Close the dismissible content and show the open button.
 *
 * @param {MouseEvent} event - click event
 */
function closeDismissibleContent(event) {
    event.preventDefault();
    this.classList.add('collapsed');
}

/**
 * Open the dismissible content and hide the open button.
 *
 * @param {MouseEvent} event - click event
 */
function openDismissibleContent(event) {
    event.preventDefault();
    this.classList.remove('collapsed');
}



// WEBPACK FOOTER //
// ./src/js/flexible-layouts.js